// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of ProjectTag
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## ProjectTag Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ProjectTag.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## ProjectTag Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ProjectTag.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectTag Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ProjectTag.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectTag Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.ProjectTag.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectTag Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.ProjectTag.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
